import { Controller } from "@hotwired/stimulus"

// Reveals the argument input a cond (ElseIf) predicate needs: comparison
// predicates (equal / not_equal / greater_than / …) show a numeric comparand,
// `match` shows a regex pattern, and `present` / `empty` show nothing. The
// predicate <select> (data-cond-branch-predicate) drives which arg target
// (data-arg) is visible so the operator instantly sees the relevant field.
export default class extends Controller {
  static targets = ["arg"]

  static COMPARISON = [
    "equal", "not_equal", "greater_than", "less_than",
    "greater_than_equal", "less_than_equal",
  ]

  connect() {
    this.toggle()
  }

  toggle() {
    const predicate = this.predicateValue
    const visibleArg = this.argFor(predicate)
    this.argTargets.forEach((el) => {
      el.hidden = el.dataset.arg !== visibleArg
    })
  }

  argFor(predicate) {
    if (this.constructor.COMPARISON.includes(predicate)) return "comparand"
    if (predicate === "match") return "pattern"
    return null
  }

  get predicateValue() {
    const select = this.element.querySelector("[data-cond-branch-predicate]")
    return select ? select.value : null
  }
}
